export const MSG001 = { code: "MGS001", message: "No hay conexión a internet" };
export const MSG002 = {
  code: "MGS002",
  message: "Tienes soportes pendientes por enviar",
};
export const MSG003 = {
  code: "MGS003",
  message: "Sesión no iniciada correctamente",
};
export const MSG408 = {
  msg: "408",
  message: "No hay conexión a internet",
  data: {},
};
export const ALERT001 = "Debes guardar primero el documento maestro";
export const ALERT002 = "Debes guardar primero tus cambios";
